/**
 * Core Skeleton — Loading placeholder with theme-aware animation.
 */
import React from 'react';
import { cn } from '@/lib/utils';

export interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
  width?: string | number;
  height?: string | number;
  lines?: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, variant = 'rounded', width, height, lines }) => {
  const base = "animate-pulse bg-slate-200 dark:bg-slate-700";
  const shapes: Record<string, string> = {
    text: 'rounded h-4',
    circular: 'rounded-full',
    rectangular: 'rounded-none',
    rounded: 'rounded-lg',
  };

  if (lines) {
    return (
      <div className={cn("space-y-2", className)}>
        {Array.from({ length: lines }).map((_, i) => (
          <div key={i} className={cn(base, shapes.text, i === lines - 1 ? 'w-3/4' : 'w-full')} style={{ height }} />
        ))}
      </div>
    );
  }

  return <div className={cn(base, shapes[variant], className)} style={{ width, height: height || (variant === 'text' ? 16 : undefined) }} />;
};

export const SkeletonCard: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("bg-white dark:bg-slate-900 rounded-2xl border border-gray-100 dark:border-slate-800 p-5 space-y-3", className)}>
    <div className="flex items-center gap-3">
      <Skeleton variant="circular" width={40} height={40} />
      <div className="flex-1 space-y-2">
        <Skeleton variant="text" className="w-3/4" />
        <Skeleton variant="text" className="w-1/2" />
      </div>
    </div>
    <Skeleton variant="rounded" height={80} className="w-full" />
    <Skeleton variant="text" lines={2} />
  </div>
);
export default Skeleton;
